import { DataBean } from "../DataBean";

export class FixedAssetItemReportColumn extends DataBean {

    public async getFixedAssetItemReportColumnEnabled(isEnabled: boolean | null, regexStr: string | null, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getFixedAssetItemReportColumnEnabled_Boolean_String_Number_Number", [isEnabled, regexStr, page, recordsPerPage]);
    }

    public async createFixedAssetItemReportColumn(arg: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_createFixedAssetItemReportColumn_Number", [arg]);
    }

    public async updateFixedAssetItemReportColumn(bean: any): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.quickdataerp.bean.fixedassets.FixedAssetItemReportColumn_updateFixedAssetItemReportColumn_com.quickdataerp.bean.fixedassets.FixedAssetItemReportColumn",
            [
                {
                    "DataBeanProperties": bean,
                    "DataBeanName": "com.quickdataerp.bean.fixedassets.FixedAssetItemReportColumn"
                }
            ]
        );
    }

}
